import { render, staticRenderFns } from "./dashboard-v2.page.vue?vue&type=template&id=2c3a84b4&scoped=true"
import script from "./dashboard-v2.page.vue?vue&type=script&lang=js"
export * from "./dashboard-v2.page.vue?vue&type=script&lang=js"
import style0 from "./dashboard-v2.page.vue?vue&type=style&index=0&id=2c3a84b4&prod&lang=scss"
import style1 from "./dashboard-v2.page.vue?vue&type=style&index=1&id=2c3a84b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a84b4",
  null
  
)

export default component.exports